import { capi } from "..";
import { QualityferDTOout } from "./DTOs/qualityferDTOout";
import { QualityferSubrogatesDTOin } from "./DTOs/qualityferSubrogatesDTOin";

export const qualityferSubrogates = (qualityferSubrogatesDTOin: QualityferSubrogatesDTOin): Promise<QualityferDTOout> => {
    return capi.post('/thirdparty/qualityfer-subrogates', qualityferSubrogatesDTOin);
}